import { render, staticRenderFns } from "./sobre.vue?vue&type=template&id=f8f7493a&scoped=true"
import script from "./sobre.vue?vue&type=script&lang=js"
export * from "./sobre.vue?vue&type=script&lang=js"
import style0 from "./sobre.vue?vue&type=style&index=0&id=f8f7493a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f7493a",
  null
  
)

export default component.exports